<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row class="pt-sm-1">
          <b-col sm="1">
            <span class="card-title wise-card-title">검색 조건</span>
          </b-col>
          <b-col sm="1"><strong>검색어</strong></b-col>
          <b-col sm="2">
            <b-form-select id="basicSelect" v-model="queryParams.searchType" :plain="true" :options="productSearchType" :value="'all'"></b-form-select>
          </b-col>
          <b-col sm="6">
              <b-form-input v-model="queryParams.keyword" placeholder="" v-on:keyup="$event.keyCode === 13 ? findDrNoticeList() : ''"></b-form-input>
          </b-col>
          <b-col sm="2" style="text-align: center;">
              <b-button variant="primary" style="width: 100%;" v-on:click="findDrNoticeList()">검색</b-button>
          </b-col>
        </b-row>

        <b-row class="pt-sm-1">
          <b-col sm="1"></b-col>
          <b-col sm="1"><strong>기간검색</strong></b-col>
          <b-col sm="2">
            <date-picker v-model="fullDateTmp"
                        type="date"
                        range
                        placeholder="조회기간 선택"
                        :lang="datepickerLang"
                        @change="handleDateRangeChange"
                        style="width: 100%;"
            />
          </b-col>
          <b-col sm="5">
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
            <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
            <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>

    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                <span style="color:#ea0000; font-weight:bold; font-size:15px" v-if="drDeleteRows.length == 0">* 클릭 하시면 상세내역 페이지로 이동합니다.</span>
                <span style="color:#222222; font-weight:bold; font-size:15px" v-if="drDeleteRows.length > 0">선택된 데이터 : {{drDeleteRows.length}}</span>
                <!-- <b-button size="sm" variant="info" v-on:click="drNoticeDeleteClear()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 clear_button_on' : 'mx-1 clear_button_off'"><h5 style="margin-bottom:0px"><i class="fa fa-list"></i> 초기화</h5></b-button> -->
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="4" class="my-1">
                <b-button variant="outline-danger" style="float:right" v-on:click="drNoticeDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1' : 'mx-1'">삭제</b-button>
              </b-col>
              <b-col md="1" class="my-1">
                <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row>
              <b-col sm="1"></b-col>
              <b-col sm="12">
                <b-table
                  striped
                  hover
                  :selectable="letterListSelect"
                  :select-mode="'multi'"
                  :fields="fieldItems"
                  :items="items"
                  :busy="items == 0"
                  :current-page="currentPage"
                  :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows(data.item)" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>
                  <template slot="rnum" slot-scope="data">
                    <div>{{data.item.rnum}}</div>
                  </template>
                  <template slot="use_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" variant="primary" v-model="data.item.use_yn" v-on:change="noticeUseSwitch(data.item,data.item.notice_code)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>

                    <!-- <label class="switch switch-3d switch-primary">v-model="data.item.active_yn"
                      <input type="checkbox" class="switch-input" value="true" :checked="data.item.use_yn == 'Y'" v-on:change="noticeUseSwitch(data.item.notice_code,data.item)">
                      <span class="switch-label"></span>
                      <span class="switch-handle"></span>
                    </label> -->
                  </template>
                  <template slot="top_yn" slot-scope="data">
                    <i v-show="data.item.top_yn == 'Y'" class="fa fa-check"></i>
                  </template>
                  <template slot="subject" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="noticeInfoGo(data.item)">{{data.item.subject}}</a></div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="1"></b-col>
              <b-col sm="12" class="my-1">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="listRows"
                  :per-page="perPage"
                  align="center"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/customer/notice/form?status=insert'">신규등록</b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>



</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { codeAPI } from '../../common/code.js';
import swal from 'sweetalert2'
import cSwitch from '../../components/Switch'

const moment = require("moment");

export default {
  components: {
    cSwitch,
    DatePicker,
  },
  data() {
    return {
      datepickerLang: {
          yearFormat: "YYYY년",
          monthFormat: "M월",
          days:["일","월","화","수","목","금","토"]
      },
      fullDateTmp: [],
      reporturltype: this.$route.params.reporturltype,
      letterListSelect: false,
      dr_topdeth_code: '',
      dr_rtype: '',
      resultCateDatas: [], // code.js 각 코드들의 결과값
      selectCateItems: [], // 상단 구분 셀렉트 박스 코드값
      productSearchType: [
        {text:'전체', value:'all'},
        {text:'제목', value:'pname'},
        {text:'내용', value:'pcontents'},
      ], // 상단 구분 셀렉트 박스 코드값
      myToggle: false,
      // totalRows: 30,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      drDeleteRows: [],
      searchData: {},
      queryParams: {
        use_yn: 'Y',
        searchType: 'all',
        // day_code: 'dayall',
        day_code: 'default',
        start_date: moment().startOf('month').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
      },
      fieldItems: [{
        'selectcheck': {
          'label': '선택',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'width': '70px'
          }
        }
      },{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdClass': 'text-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center',
             'width': '100px'
          }
        }
      }, {
        'use_yn': {
          'label': '노출여부',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center',
             'width': '120px'
          }
        }
      }, {
        'top_yn': {
          'label': '상단공지',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center',
             'width': '120px'
          }
        }
      }, {
        'subject': {
          'label': '제목',
          // 'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'reg_name': {
          'label': '등록자',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'width': '120px'
          }
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
            'width': '150px'
          }
        }
      }],
      items: [],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'letterListSelect'() {
      this.drDeleteRows = [];
    }
  },
  mounted: function() {
     // /contents/trendbrief
     this.noticeInit();
  },
  methods: {
    noticeInit() {
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.queryParams = {
        searchType: 'all',
        // day_code: 'dayall',
        day_code: 'default',
      };

      // 최초 날짜 갱신(이번달)
      // self.dateRange('this_month');
      // 최초 리스트 갱신
      self.findDrNoticeList();
    },
    // 메소드명 : findDrNoticeList()
    // ### 리포트 조회 ###
    // 리포트를 DB테이블에서 조회한다.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - parentCode(그룹코드 값)
    //  - depth(대분류,소분류 구분)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2019.11.11  황경현   최초작성
    // *************************
    findDrNoticeList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('noticeObjs', param);

      self.$http.post('/api/select/drNoticeList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
          });
        })
    },
    drListRows() {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.notice_code);
        }
      });
    },
    drNoticeDelete(){
      var self = this;
      swal.fire({
        title: '공지사항 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 공지사항 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/drNotice?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '공지사항이 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findDrNoticeList();
              });
          })
        }else{
          // cansel
        }
      })
    },
    drNoticeDeleteClear() {
      this.drDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    noticeInfoGo(row) {
      var self = this;
      self.$session.set('noticeCode', row.notice_code);
      location.href = '#/customer/notice/info';
    },
    // 날짜 정의
    dateRange(flag) {
      let endDate = new Date();
      let startDate = new Date();

      if(flag == 'this_month'){
        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
      }else if(flag == '1WEEK'){
        startDate.setDate(endDate.getDate() - 7);
      }else if(flag == '1MONTH'){
        startDate.setMonth(endDate.getMonth() - 1);
      }else if(flag == '6MONTH'){
        startDate.setMonth(endDate.getMonth() - 6);
      }else if(flag == '1YEAR'){
        startDate.setFullYear(endDate.getFullYear() - 1);
      }
      this.fullDateTmp = [startDate, endDate];
      if(flag == 'ALL'){
          this.fullDateTmp = [];
      }
      this.handleDateRangeChange();
    },
    handleDateRangeChange() {
      var self = this;
      if(self.fullDateTmp.length > 0){
        self.queryParams.start_date = moment(self.fullDateTmp[0]).format("YYYY-MM-DD");
        self.queryParams.end_date = moment(self.fullDateTmp[1]).format("YYYY-MM-DD");
      }else{
        self.queryParams.start_date = '';
        self.queryParams.end_date = '';
      }
    },
    noticeUseSwitch(item, notice_code) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.queryParams.reg_id = self.$session.get('userId');
      self.queryParams.notice_code = notice_code;
      self.queryParams.use_yn = item.use_yn;

      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('noticeObj', param);

      self.$http.post('/api/update/drNoticeUseYn?access_token='+token, data, null)
        .then((result) => {
          console.log("결과",result);
      })
    },
  }
}
</script>
<style lang="css" scoped>
  .delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
  .delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
  .clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
  .clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}
</style>



// WEBPACK FOOTER //
// src/views/customer/NoticeList.vue